export const enterpriseEditionUrl = "https://www.openproject.org/enterprise-edition/?op_edtion=community-edition";

export const enterpriseDemoUrl = "https://www.openproject.org/enterprise-demo/";
